import * as React from 'react';
import { FormGroup, Label } from '../../common/formInputsV2/styles/common';

const formatWithApostrophe = (val) => {
  if (!val) return '';
  const parts = val.split(',');
  const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  return parts.length > 1 ? `${intPart},${parts[1]}` : intPart;
};

export default function CauzioniPriceInput({
  label, name, value, onChange, onBlur, error, valid, hint, suffix = '€',
}) {
  const inputRef = React.useRef(null);
  const [focused, setFocused] = React.useState(false);
  const [raw, setRaw] = React.useState('');

  const safeValue = value == null ? '' : String(value);

  const toDisplay = (v) => {
    if (!v) return '';
    const normalized = v.replace('.', ',');
    return `${formatWithApostrophe(normalized)} ${suffix}`;
  };

  const displayValue = focused ? raw : toDisplay(safeValue);

  const handleChange = (e) => {
    let input = e.target.value.replace(/[^\d,.]/g, '');
    input = input.replace('.', ',');
    const commaIdx = input.indexOf(',');
    if (commaIdx !== -1) {
      input = input.slice(0, commaIdx + 1) + input.slice(commaIdx + 1).replace(/,/g, '').slice(0, 2);
    }
    setRaw(input);
    onChange(input.replace(',', '.'));
  };

  const handleFocus = () => {
    setFocused(true);
    setRaw(safeValue.replace('.', ','));
  };

  const handleBlur = () => {
    setFocused(false);
    if (onBlur) onBlur();
  };

  return (
    <FormGroup>
      {label !== undefined && (
        <Label>
          {label}
          {' '}
          (
          {suffix}
          )
        </Label>
      )}
      <input
        ref={inputRef}
        className={`form-control ${error ? 'is-invalid' : ''} ${valid ? 'is-valid' : ''}`}
        type="text"
        name={name}
        value={displayValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      <div className="invalid-feedback">{error}</div>
      {hint && <p className="form-input-hint">{hint}</p>}
    </FormGroup>
  );
}
